import React, { useRef } from 'react';
import useSetupCrsOmni from './use-setup-crs-omni';

export default function CrsOmniWidget() {
  const omniWrapperRef = useRef(null);

  useSetupCrsOmni(omniWrapperRef.current);

  return (
    <div className="crs-omni-widget" data-testid="crs-omni-widget">
      <div className="omni-widget-mfe-wrapper">
        <div ref={omniWrapperRef} className="product__actions--availability-wrapper no-linkify scope-1892" />
      </div>
    </div>
  );
}
